import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/fronteu/ampmworldfrontend/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/home/fronteu/ampmworldfrontend/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/home/fronteu/ampmworldfrontend/src/components/ui/button/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/fronteu/ampmworldfrontend/src/views/join-us/components/content/card/index.module.scss");
;
import(/* webpackMode: "eager" */ "/home/fronteu/ampmworldfrontend/src/views/join-us/components/content/quote/index.module.scss");
;
import(/* webpackMode: "eager" */ "/home/fronteu/ampmworldfrontend/src/views/join-us/components/footer/index.module.scss");
;
import(/* webpackMode: "eager" */ "/home/fronteu/ampmworldfrontend/src/components/entities/breadcrumbs/index.module.scss");
;
import(/* webpackMode: "eager" */ "/home/fronteu/ampmworldfrontend/src/components/ui/container/index.module.scss");
;
import(/* webpackMode: "eager" */ "/home/fronteu/ampmworldfrontend/src/components/entities/description-block/index.module.scss");
;
import(/* webpackMode: "eager" */ "/home/fronteu/ampmworldfrontend/src/views/join-us/components/header/index.module.scss");
